import { render, staticRenderFns } from "./DynamicFooterPage.vue?vue&type=template&id=c0c5bb24"
import script from "./DynamicFooterPage.vue?vue&type=script&lang=ts"
export * from "./DynamicFooterPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports